import React, {useEffect, useState} from 'react';
import './App.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';

// import {Load} from './pages';
import { Footer, Navbar } from './components';

const Home = React.lazy(() => import('./pages/Home'));
const Inicio = React.lazy(() => import('./pages/Inicio'));
const Desayunos = React.lazy(() => import('./pages/Desayunos'));
const Bebidas = React.lazy(() => import('./pages/Bebidas'));

ReactGA.initialize(process.env.REACT_APP_GA_APIKEY);

function App() {

  const [showMenu, setShowMenu] = useState(true)

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/my-path" });
  },);
  
  return (
    <div className='app'>
      <BrowserRouter>
        { showMenu && 
          <Navbar />
        } 
        <div>
          <Routes>
              <Route path="/" element={ <Home funcMenu={setShowMenu}/>} />
              <Route path="/comida" element={<Inicio /> } />
              <Route path="/desayuno" element={<Desayunos/>} />
              <Route path="/bebidas" element={<Bebidas />} />
          </Routes>
        </div>
        { showMenu &&
            <Footer />
        }  
      </BrowserRouter>
    </div>
  );
}

export default App;